import { render, staticRenderFns } from "./_info.vue?vue&type=template&id=8d91c92a"
import script from "./_info.vue?vue&type=script&lang=js"
export * from "./_info.vue?vue&type=script&lang=js"
import style0 from "./_info.vue?vue&type=style&index=0&id=8d91c92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports